// these values match campaign "type" field from backend
export const RECIPIENTS_TYPE_REGULAR = 'regular';
export const RECIPIENTS_TYPE_AUTOMATED = 'automated';
export const RECIPIENTS_TYPE_MODERATED = 'moderated';

// these values match campaign "trigger_condition" from backend
export const RECIPIENTS_AUTO_TRIGGER_NEW = 'new-shareholder';
export const RECIPIENTS_AUTO_TRIGGER_EXIT = 'shareholder-exit';
export const RECIPIENTS_AUTO_TRIGGER_THRESHOLD = 'threshold-milestone';

// map recipient triggers to a user friendly label
export const RECIPIENTS_TRIGGER_LABELS = {
  [RECIPIENTS_AUTO_TRIGGER_NEW]: 'New Investors',
  [RECIPIENTS_AUTO_TRIGGER_EXIT]: 'Investors exit',
  [RECIPIENTS_AUTO_TRIGGER_THRESHOLD]: 'Threshold milestone',
};
